import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { IModelValidator } from '../../shared/interfaces/model-validator.interface';

export const REFERENCE_SCHEMA = Object.freeze({
  TYPE: '',
  ID: '',
  REFERENCE_LOCAL_ID: null,
  REVISION_ID: '',
});

const RECORD = generateSchema(REFERENCE_SCHEMA);
const KEYS: any = generateKeys(REFERENCE_SCHEMA);

export class Reference extends Record(RECORD) implements IModelValidator {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get referenceLocalId(): string {
    return this.get(KEYS.REFERENCE_LOCAL_ID);
  }

  get revisionId(): string {
    return this.get(KEYS.REVISION_ID);
  }

  serialize(): Reference {
    return this.toMap().remove(KEYS.LOCAL_ID) as Reference;
  }

  hasValue(): boolean {
    return !!(this.id && this.type && this.revisionId);
  }
}
